export const getFirstWords = (text, numWords) => {
  return text ? text.split(' ').slice(0, numWords ? numWords : 6).join(' ') : null;
}